export default __webpack_public_path__ + "fonts/solutions-2.svg";